import { MdDownload } from 'react-icons/md';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { TestCaseService } from '@/api/testCase';
import { Dialog } from 'alurkerja-ui';
import { downloadFile } from '@/utils/libs/fileUtil';

export const DownloadTemplateTestCase: React.FC = () => {
  const { mutate: downloadMutate, isPending: isDownloadLoading } =
    TestCaseService.useDownloadTemplateImport();

  const downloadTemplate = () => {
    downloadMutate(undefined, {
      onSuccess: response => {
        Dialog.success({
          title: 'Success',
          description: 'Template has been downloaded',
        });

        downloadFile(response, 'TemplateTestCase.xlsx');
      },
      onError: () => {
        Dialog.error({
          title: 'Error',
          description: 'Failed to download template',
        });
      },
    });
  };

  return (
    <OutlineButton
      icon={<MdDownload />}
      onClick={() => downloadTemplate()}
      isLoading={isDownloadLoading}
    >
      Template
    </OutlineButton>
  );
};
